import { useContext, useEffect } from "react";
import { AuthenticationContext } from "../providers/authentication/authentication.provider";
import { IRouteGuardProps } from "./route.interface";
import { Navigate, useLocation } from "react-router-dom";
import { routes } from "../router/routes";
import Loading from "../../components/Loading/Loading";
import { getCookies } from "../helpers/utils";
import { COOKIES } from "../constants";
import UserProvider from "../providers/user/user.provider";
import DatProvider from "../providers/dat/dat.provider";
import ModuleProvider from "../providers/module/module.provider";
import DssProvider from "../providers/dss/dss.provider";

function RouteGuard({ children }: IRouteGuardProps) {
    const { isAuthenticated, setIsAuthenticated } = useContext(AuthenticationContext);
    const location = useLocation();

    useEffect(() => {
        const cookies = getCookies();

        if (cookies[COOKIES.REFRESH_TOKEN]) setIsAuthenticated(true);
        else setIsAuthenticated(false);
    }, [location, setIsAuthenticated]);

    if (isAuthenticated === undefined) return <Loading />;

    if (!isAuthenticated) return <Navigate to={routes.LOGIN.path} />;

    return (
        <UserProvider>
            <DatProvider>
                <ModuleProvider>
                    <DssProvider>{children}</DssProvider>
                </ModuleProvider>
            </DatProvider>
        </UserProvider>
    );
}

export default RouteGuard;
